export enum AnalyticsSources {
  FVC_STRESS = 'FVC - Stress Testing',
  FVC_PRIIPs = 'FVC - PRIIPs',
  CLOUD_RISK_PRIIPS = 'Cloud Risk - PRIIPs',
  CLOUD_RISK_STRESS = 'Cloud Risk - Stress Testing',
}

export enum AnalyticsSourcesKeys {
  FVC = 'fvc',
  FVC_PRIIPs = 'fvcPRIIPs',
  CLOUD_RISK = 'cloudRisk',
  CLOUD_RISK_STRESS = 'cloudRiskStress',
}

export const ANALYTICS_SOURCE = [
  { id: AnalyticsSourcesKeys.FVC, displayValue: AnalyticsSources.FVC_STRESS },
  {
    id: AnalyticsSourcesKeys.FVC_PRIIPs,
    displayValue: AnalyticsSources.FVC_PRIIPs,
  },
  {
    id: AnalyticsSourcesKeys.CLOUD_RISK,
    displayValue: AnalyticsSources.CLOUD_RISK_PRIIPS,
  },
  {
    id: AnalyticsSourcesKeys.CLOUD_RISK_STRESS,
    displayValue: AnalyticsSources.CLOUD_RISK_STRESS,
  },
];
